module.exports = __webpack_public_path__ + "static/media/clothing-on-hover.2590d6cf.png";